import { render } from "./chi-tiet.vue?vue&type=template&id=d61fccf6&scoped=true"
import script from "./chi-tiet.vue?vue&type=script&lang=js"
export * from "./chi-tiet.vue?vue&type=script&lang=js"

import "./chi-tiet.vue?vue&type=style&index=0&id=d61fccf6&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d61fccf6"]])

export default __exports__